import * as $ from 'jquery';
import { MediaMatcher } from '@angular/cdk/layout';
import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  ViewChild,
  HostListener,
  Directive,
  AfterViewInit,
  OnInit
} from '@angular/core';
import { MenuItems } from '../../shared/menu-items/menu-items';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../../shared/dialog/bottomSheet/bottom-sheet';
import { SharedService } from '../../shared/shared.services';
import { SnackBarService } from '../../shared/service/snack.bar.service';
import { UserService } from '../../shared/service/user.service';
import { Router, NavigationEnd } from '@angular/router';

import { filter } from 'rxjs/operators';
import { routerTransition } from '../../shared/animations';
import { NavigationService } from '../../shared/service/navigation.service';
import { ProjectService } from '../../shared/service/project.service';
import { SwitchAccountDialog } from '../../shared/dialog/switch-account-dialog/switch-account-dialog';

@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: [],
  providers: [MatBottomSheet],
  animations: [
    routerTransition()
  ]
})
export class FullComponent implements OnDestroy, AfterViewInit, OnInit {

  @ViewChild('snav', { static: true }) public snav: MatSidenav;

  mobileQuery: MediaQueryList;
  minisidebar: boolean;
  showHide: boolean;
  showeletter: boolean;
  sidebarOpened;

  public config: PerfectScrollbarConfigInterface = {};
  private _mobileQueryListener: () => void;

  constructor(
    public userSvc: UserService,
    private navigationService: NavigationService,
    private bottomSheet: MatBottomSheet,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    public dialog: MatDialog,
    public sharedService: SharedService,
    private snackBarService: SnackBarService,
    public userService: UserService,
    private projectService: ProjectService,
    private router: Router
  ) {
    // router.events.pipe(
    //   filter(event => event instanceof NavigationEnd)  
    // ).subscribe((event: NavigationEnd) => {
    //   this.showeletter = (event.url.indexOf("/general-setting/new-e-letter")===0 || event.url.indexOf("/general-setting/edit-e-letter") ===0)?true:false;
    //   this.showeletter?this.snav.toggle(false):this.snav.toggle(true)
    // });
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.userService.AccountName
  }

  getRouteAnimation(outlet) {
    return this.navigationService.animationValue;
  }


  openBS() {
    event.stopPropagation();
    var a = this.bottomSheet.open(BottomSheet, { data: 1 });
    a.afterDismissed().subscribe((x) => {
    });
  }

  ngOnInit() {
    this.sharedService.sideNav = this.snav;
    this.userService.Init();
    this.projectService.Init();
    if(this.snav){
      this.snav.closedStart.subscribe(x => {
        $('.footer-menu').css('width', 'calc(100% - 30px)');
      });
      
    this.snav.openedStart.subscribe(x => {
      $('.footer-menu').css('width', '');
    });
    }
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  ngAfterViewInit() {
    (<any>$('.srh-btn, .cl-srh-btn')).on('click', function () {
      (<any>$('.app-search')).toggle(200);
    });
  }
  switchAccontDialog() {
    if (this.userSvc.AccountList.length == 0) return ;
    this.dialog.open(SwitchAccountDialog, {
      width: "320px",
      panelClass: "switch-project-dialog",
    });
  }
}
